import LoadingIcon from "../Icon/LoadingIcon"

const LoadingCenter = (props) => {

    const { className, size } = props;

    return (
        <div className={"text-center " + className}>
            <LoadingIcon className={size ? size : "fa-5x"}/>
        </div>
    )
}

export default LoadingCenter;